import React from 'react'
import { InputComponent, TitleComponent } from '@src/components/UtmGenerator'
import {
  GroupsPageAddressPrefixURL,
  GroupsTrafficListCheckbox,
  GroupsTrafficParameters
} from '@src/containers/UtmGenerator/groups'
import { useHTTPContext } from '@src/containers/UtmGenerator/context'
import note from '@src/containers/UtmGenerator/assets/note.png'
import settings from '@src/containers/UtmGenerator/assets/settings.png'

import * as Styled from './Info.styled'

const Info = () => {
  const { linkPage, getLinkPage } = useHTTPContext()

  return (
    <Styled.Section>
      <div className="container">
        <Styled.Header>
          <TitleComponent text="Ваша страница" icon={note} />
          <GroupsPageAddressPrefixURL />
          <InputComponent
            id="utm-generator__prefix-url"
            labelText="site.ru"
            type="text"
            name="prefix-url"
            onChange={getLinkPage}
            value={linkPage}
          />
        </Styled.Header>
        <TitleComponent text="Источник трафика" icon={settings} />
        <GroupsTrafficListCheckbox />
        <GroupsTrafficParameters />
      </div>
    </Styled.Section>
  )
}

export default Info
